

export default function Privacy() {
  return (
    <div className="bg-[var(--t-bg)] min-h-screen text-[var(--t-text)] pt-32 pb-40">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-6xl font-black mb-4 italic uppercase tracking-tighter">
          Privacy <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">Protocol</span>
        </h1>
        <p className="text-[var(--t-text-muted)] font-black uppercase tracking-[0.3em] mb-16 text-xs">Last Updated: May 14, 2026</p>
        
        <div className="prose prose-invert max-w-none space-y-12 text-[var(--t-text-muted)] font-medium leading-relaxed">
          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">1. Data Sovereignty</h2>
            <p>
              At WholeScale OS, we operate on a "Sovereign First" principle. Unlike legacy CRMs, we do not view your lead data, property records, or communication history as our asset. Your data is your empire. We provide the high-performance infrastructure to manage it.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">2. Information Architecture</h2>
            <p>
              We collect information required to maintain mission-critical performance:
            </p>
            <ul className="list-disc pl-6 space-y-4">
              <li><strong className="text-white">Identity:</strong> Name and email address used for secure authentication via Supabase.</li>
              <li><strong className="text-white">Communication:</strong> Metadata regarding SMS and email transmissions processed through our gateways.</li>
              <li><strong className="text-white">Neural Inputs:</strong> Any data you intentionally provide to our AI models (Gemini, Claude, etc.) for triage and processing.</li>
            </ul>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">3. Neural Processing & AI</h2>
            <p>
              When utilizing our AI-powered lead triage, your data is processed by third-party LLM providers (Google, Anthropic, OpenAI). We utilize enterprise-grade API agreements to ensure your data is not used to train global models. Your competitive edge remains yours.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">4. Infrastructure Security</h2>
            <p>
              Your data is housed in world-class facilities provided by Supabase and AWS. All data is encrypted at rest using AES-256 and in transit via TLS 1.3. We implement strictly enforced Row Level Security (RLS) to ensure that only you can access your empire's records.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">5. Retention & Liquidation</h2>
            <p>
              You maintain the right to liquidate your data at any time. Upon request, or upon closing your account, we will purge all associated records from our active databases within 30 days, subject to any legal retention requirements.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">6. Command Contact</h2>
            <p>
              For inquiries regarding data protection or the exercise of your privacy rights, contact the WholeScale Engineering Core at: <span className="text-indigo-400 font-black">wholescaleos@gmail.com</span>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

